import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVICE_URL } from '../../../../tokens';

@Injectable({
  providedIn: 'root',
})
export class MedicationSearchFormService {

  constructor(private http: HttpClient, @Inject(SERVICE_URL) private serviceUrl: any) { }

  getSpecialties(networkId: string): Observable<any> {
    const params = new HttpParams({
      fromObject: {
        'networkId': networkId
      }
    });

    return this.http.get(this.serviceUrl + 'Specialties', { params: params });
  }

  getDrugs(search: string, formularyId: string) {
    formularyId = formularyId && formularyId.split('displayKey_').length > 1 ? formularyId.split('displayKey_')[1] : formularyId;  
        
    const params = new HttpParams({
      fromObject: {
        'api-version': 1,
        'formularyId': formularyId
      }
    });

    return this.http.get(this.serviceUrl + 'Drugs', { params: params });
  }

  createHttpErrorResponseMessage(status: number): string {
    let msg = '';
    if (status === 400 || status === 404) {
      msg = `An unexpected error has occurred. Please contact your administrator.`;
    } else if (status === 401 || status === 403 || status === 405) {
      msg = `System authorization is invalid. Please contact your administrator.`;
    } else {
      msg = `Server Error: Something unexpected happened. Please contact your administrator.`;
    }
    return msg;
  }

  isDesktop() {
    const userAgent: string = navigator.userAgent || navigator.vendor;
    const isMobileDevice = (): boolean => {
      const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
      return regexs.some((b) => userAgent.match(b))
    }
    const isTabletDevice = (): boolean => {
      const regex = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/
      return regex.test(userAgent.toLowerCase())
    }
    return !isMobileDevice() && !isTabletDevice();
  }
}
